const avatarConfirmTenant = {
  logo: 'LOGO'
};

export default avatarConfirmTenant;
